// extracted by mini-css-extract-plugin
module.exports = {"responsive":"StoreFeedActivityModal_responsive_2UASI"};